export const DRAWER_EVENTS = {
  OPEN: 'drawer_open',
  CLOSED: 'drawer_closed',
};
